import React from 'react';

const ConfirmationTick = () => {
  return (
    <div className="confirmation-tick">
      <svg
        width="55px"
        height="44px"
        viewBox="0 0 55 44"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Check-in-Kiosk---Bishops"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Confirm-Check-in"
            transform="translate(-247.000000, -164.000000)"
            stroke="#742d2d"
            strokeWidth="10"
          >
            <g id="Group" transform="translate(251.000000, 158.164974)">
              <polyline
                id="Path-2-Copy-2"
                points="0.383937843 28.4543144 14.2275931 42.2979696 46.9229042 9.60265849"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default ConfirmationTick;
